module.exports = __webpack_public_path__ + "img/light-switch-on.649b45c9.svg";